import styled from 'styled-components';

export const HeaderContainer = styled.header`
  width: 100%;
`;
